<template>
    <div v-if="showBanner" class="cookie-banner">
        <div class="cookie-content">
            <div class="cookie-text">
                <h4>Cookie-Einstellungen</h4>
                <p>
                    Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten.
                    Einige Cookies sind technisch notwendig, während andere uns helfen, die Website zu verbessern.
                    <router-link to="/datenschutz">Mehr erfahren</router-link>
                </p>
            </div>
            <div class="cookie-buttons">
                <button @click="acceptAll" class="btn-accept">Alle akzeptieren</button>
                <button @click="acceptEssential" class="btn-essential">Nur notwendige</button>
                <button @click="showSettings = true" class="btn-settings" v-if="!showSettings">Einstellungen</button>
            </div>
            <div v-if="showSettings" class="cookie-settings">
                <div class="cookie-option">
                    <label>
                        <input type="checkbox" checked disabled>
                        <span>Notwendige Cookies</span>
                    </label>
                    <small>Erforderlich für die Grundfunktionen der Website</small>
                </div>
                <div class="cookie-option">
                    <label>
                        <input type="checkbox" v-model="analyticsEnabled">
                        <span>Analyse-Cookies (Google Analytics)</span>
                    </label>
                    <small>Helfen uns, die Nutzung der Website zu verstehen</small>
                </div>
                <button @click="saveSettings" class="btn-save">Einstellungen speichern</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CookieBanner',
    data() {
        return {
            showBanner: false,
            showSettings: false,
            analyticsEnabled: false
        }
    },
    mounted() {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            this.showBanner = true;
        } else {
            const settings = JSON.parse(consent);
            if (settings.analytics) {
                this.loadGoogleAnalytics();
            }
        }
    },
    methods: {
        acceptAll() {
            const settings = {
                essential: true,
                analytics: true,
                timestamp: new Date().toISOString()
            };
            localStorage.setItem('cookie-consent', JSON.stringify(settings));
            this.loadGoogleAnalytics();
            this.showBanner = false;
        },
        acceptEssential() {
            const settings = {
                essential: true,
                analytics: false,
                timestamp: new Date().toISOString()
            };
            localStorage.setItem('cookie-consent', JSON.stringify(settings));
            this.showBanner = false;
        },
        saveSettings() {
            const settings = {
                essential: true,
                analytics: this.analyticsEnabled,
                timestamp: new Date().toISOString()
            };
            localStorage.setItem('cookie-consent', JSON.stringify(settings));
            if (this.analyticsEnabled) {
                this.loadGoogleAnalytics();
            }
            this.showBanner = false;
        },
        loadGoogleAnalytics() {
            // Google Analytics 4 - Ersetze GA_MEASUREMENT_ID mit deiner ID
            const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // TODO: Deine GA4 ID hier eintragen

            if (GA_MEASUREMENT_ID === 'G-XXXXXXXXXX') {
                console.log('Google Analytics: Measurement ID noch nicht konfiguriert');
                return;
            }

            // gtag.js laden
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
            document.head.appendChild(script);

            // gtag initialisieren
            window.dataLayer = window.dataLayer || [];
            function gtag(){window.dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', GA_MEASUREMENT_ID, {
                anonymize_ip: true // DSGVO-konform: IP-Anonymisierung
            });

            window.gtag = gtag;
        }
    }
}
</script>

<style scoped>
.cookie-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #1a1a2e;
    color: #fff;
    padding: 20px;
    z-index: 9999;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
}

.cookie-content {
    max-width: 1200px;
    margin: 0 auto;
}

.cookie-text h4 {
    margin: 0 0 10px 0;
    font-size: 18px;
}

.cookie-text p {
    margin: 0 0 15px 0;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.8);
}

.cookie-text a {
    color: #fff;
    text-decoration: underline;
}

.cookie-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.cookie-buttons button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
}

.btn-accept {
    background: #010215;
    color: #fff;
}

.btn-accept:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(1, 2, 21, 0.4);
}

.btn-essential {
    background: transparent;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.btn-essential:hover {
    border-color: #fff !important;
}

.btn-settings {
    background: transparent;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: underline;
}

.cookie-settings {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.cookie-option {
    margin-bottom: 15px;
}

.cookie-option label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
}

.cookie-option input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.cookie-option small {
    display: block;
    margin-left: 28px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
}

.btn-save {
    background: #010215;
    color: #fff;
    margin-top: 10px;
}

@media (max-width: 768px) {
    .cookie-banner {
        padding: 15px;
    }

    .cookie-buttons {
        flex-direction: column;
    }

    .cookie-buttons button {
        width: 100%;
    }
}
</style>
